{
  "$schema": "./bibliotecas.schema.json",
  "bibliotecas": [
    {
      "nome": "Arquivos",
      "descrição": "Esta biblioteca permite ler e escrever arquivos",
      "constantes": [
        {
          "nome": "MODO_ACRESCENTAR",
          "valor": 2,
          "descrição": "indica à biblioteca que o arquivo deve ser aberto apenas para escrita\nque acrescenta ao final do arquivo\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MODO_ESCRITA",
          "valor": 1,
          "descrição": "indica à biblioteca que o arquivo deve ser aberto apenas para escrita",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MODO_LEITURA",
          "valor": 0,
          "descrição": "indica à biblioteca que o arquivo deve ser aberto apenas para leitura",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "abrir_arquivo",
          "descrição": "Abre um arquivo para leitura ou escrita. No modo leitura, caso o arquivo informado não exista, será gerado um erro. No modo escrita, caso o arquivo informado não exista, ele tentará ser criado, se a criação do arquivo falhar, então será gerado um erro.\n\n**IMPORTANTE:** ao abrir o arquivo no modo de escrita, o conteúdo do arquivo é apagado para que o novo conteúdo seja escrito. Caso seja necessário manter o conteúdo atual do arquivo, deve-se armazená-lo em uma variável e depois escrevê-lo novamente no arquivo.",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço de memória onde o arquivo foi carregado"
          },
          "parâmetros": [
            {
              "nome": "caminho_arquivo",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome do arquivo que se quer abrir"
            },
            {
              "nome": "modo_acesso",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "determina se o arquivo será aberto para leitura ou para escrita.\nConstantes aceitas: MODO_LEITURA | MODO_ESCRITA | MODO_ACRESCENTAR\n"
            }
          ]
        },
        {
          "nome": "apagar_arquivo",
          "descrição": "Remove um arquivo do sistema de arquivos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho_arquivo",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho do arquivo que se quer apagar"
            }
          ]
        },
        {
          "nome": "arquivo_existe",
          "descrição": "Verifica se um determinado arquivo existe no sistema de arquivos",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o arquivo existir\n"
          },
          "parâmetros": [
            {
              "nome": "caminho_arquivo",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho do arquivo que se quer verificar"
            }
          ]
        },
        {
          "nome": "criar_pasta",
          "descrição": "Cria pastas no caminho informado caso elas não existam",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "Caminho onde as pastas serão criadas"
            }
          ]
        },
        {
          "nome": "escrever_linha",
          "descrição": "Escreve uma linha no arquivo. Esta função só é executada se o arquivo\nestiver aberto em modo de escrita. Se o arquivo estiver em modo de leitura,\nserá gerado um erro.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "linha",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "a linha a ser escrita no arquivo"
            },
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do arquivo"
            }
          ]
        },
        {
          "nome": "fechar_arquivo",
          "descrição": "Fecha um arquivo aberto anteriormente",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            },
            "descrição": ""
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do arquivo"
            }
          ]
        },
        {
          "nome": "fim_arquivo",
          "descrição": "Verifica se o arquivo chegou ao fim, isto é, se todas as linhas já\nforam lidas. Esta função só é executada se o arquivo estiver aberto em modo\nde leitura. Se o arquivo estiver em modo de escrita, será gerado um erro.\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o arquivo tiver chegado ao fim. Caso contrário\nretorna `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do arquivo"
            }
          ]
        },
        {
          "nome": "ler_linha",
          "descrição": "Lê a próxima linha do arquivo. Esta função só é executada se o arquivo\nestiver aberto em modo de leitura. Se o arquivo estiver em modo de escrita,\nserá gerado um erro.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "Uma `cadeia` contendo o conteúdo da linha lida."
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do arquivo"
            }
          ]
        },
        {
          "nome": "listar_arquivos",
          "descrição": "Altera um vetor para que ele represente os arquivos existentes em um\ndiretório\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho_pai",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "Define o diretório cujas pastas serão listadas"
            },
            {
              "nome": "vetor_arquivos",
              "tipo": {
                "primitivo": "cadeia",
                "dimensão": "vetor"
              },
              "descrição": "Vetor destino que contará com os arquivos encontrados"
            }
          ]
        },
        {
          "nome": "listar_arquivos_por_tipo",
          "descrição": "Altera um vetor para que ele represente os arquivos existentes em um\ndiretório\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho_pai",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "Define o diretório cujas pastas serão listadas"
            },
            {
              "nome": "vetor_arquivos",
              "tipo": {
                "primitivo": "cadeia",
                "dimensão": "vetor"
              },
              "descrição": "Vetor destino que contará com os arquivos encontrados"
            },
            {
              "nome": "vetor_tipos",
              "tipo": {
                "primitivo": "cadeia",
                "dimensão": "vetor"
              },
              "descrição": "Vetor destino que contará com os tipos de arquivos encontrados"
            }
          ]
        },
        {
          "nome": "listar_pastas",
          "descrição": "Altera um vetor para que ele represente as pastas existentes em um\ndiretório\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho_pai",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "Define o diretório cujas pastas serão listadas"
            },
            {
              "nome": "vetor_pastas",
              "tipo": {
                "primitivo": "cadeia",
                "dimensão": "vetor"
              },
              "descrição": "Vetor destino que contará com as pastas encontradas"
            }
          ]
        },
        {
          "nome": "selecionar_arquivo",
          "descrição": "Abre uma janela que permite ao usuário navegar nos diretórios do computador e selecionar um arquivo\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "O arquivo selecionado ou uma `cadeia` vazia caso o usuário tenha cancelado.\n"
          },
          "parâmetros": [
            {
              "nome": "formatos_suportados",
              "tipo": {
                "primitivo": "cadeia",
                "dimensão": "vetor"
              },
              "descrição": "Define os formatos de arquivos que poderão ser selecionados. Um formato de arquivo é formado por uma descrição e uma lista de extensões válidas.\nA descrição deve estar separada da lista de extensões pelo caracter '|' e cada extensão deverá estar separada da outra pelo caracter ','. Ex.: 'Arquivos de texto|txt', 'Arquivos de imagem|png,jpg,jpeg,bmp'\n"
            },
            {
              "nome": "aceitar_todos_arquivos",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "Quando `verdadeiro`, inclui automaticamente um formato que permite selecionar qualquer arquivo. Este formato também será incluído se nenhum outro formato for informado no parâmetro 'formatos_suportados'\n"
            }
          ]
        },
        {
          "nome": "substituir_texto",
          "descrição": "Pesquisa por um determinado texto no arquivo e substitui todas as ocorrências por um texto alternativo\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o endereço do arquivo"
            },
            {
              "nome": "texto_pesquisa",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será pesquisado no arquivo"
            },
            {
              "nome": "texto_substituto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto pelo qual as ocorrências serão substituídas"
            },
            {
              "nome": "primeira_ocorrencia",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "confirma se substituirá apenas a primeira ocorrência no texto, caso contrário, substituirá todas\n"
            }
          ]
        }
      ]
    },
    {
      "nome": "Calendario",
      "descrição": "Esta biblioteca contém funções para obter a data e a hora atuais do computador",
      "constantes": [
        {
          "nome": "DIA_DOMINGO",
          "valor": 1,
          "descrição": "Número que representa o domingo nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_QUARTA_FEIRA",
          "valor": 4,
          "descrição": "Número que representa a quarta-feira nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_QUINTA_FEIRA",
          "valor": 5,
          "descrição": "Número que representa a quinta-feira nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_SABADO",
          "valor": 7,
          "descrição": "Número que representa o sábado nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_SEGUNDA_FEIRA",
          "valor": 2,
          "descrição": "Número que representa a segunda-feira nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_SEXTA_FEIRA",
          "valor": 6,
          "descrição": "Número que representa a sexta-feira nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "DIA_TERCA_FEIRA",
          "valor": 3,
          "descrição": "Número que representa a terça-feira nas funções de dia da semana",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_ABRIL",
          "valor": 4,
          "descrição": "Número que representa o mês de abril, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_AGOSTO",
          "valor": 8,
          "descrição": "Número que representa o mês de agosto, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_DEZEMBRO",
          "valor": 12,
          "descrição": "Número que representa o mês de dezembro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_FEVEREIRO",
          "valor": 2,
          "descrição": "Número que representa o mês de fevereiro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_JANEIRO",
          "valor": 1,
          "descrição": "Número que representa o mês de janeiro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_JULHO",
          "valor": 7,
          "descrição": "Número que representa o mês de julho, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_JUNHO",
          "valor": 6,
          "descrição": "Número que representa o mês de junho, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_MAIO",
          "valor": 5,
          "descrição": "Número que representa o mês de maio, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_MARCO",
          "valor": 3,
          "descrição": "Número que representa o mês de março, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_NOVEMBRO",
          "valor": 11,
          "descrição": "Número que representa o mês de novembro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_OUTUBRO",
          "valor": 10,
          "descrição": "Número que representa o mês de outubro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "MES_SETEMBRO",
          "valor": 9,
          "descrição": "Número que representa o mês de setembro, como em `mes_atual`",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "ano_atual",
          "descrição": "Retorna o ano da data atual do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o ano com quatro dígitos. Ex.: 2012.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "dia_mes_atual",
          "descrição": "Retorna o dia do mês da data atual do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o dia do mês, de 1 a 31. Ex.: 26.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "dia_semana_abreviado",
          "descrição": "Retorna o nome abreviado, com três letras, do dia da semana correspondente ao número informado, de 1 (domingo) a 7 (sábado).\n\nSe o número estiver fora desse intervalo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o nome abreviado, com três letras, do dia da semana. Ex.: `\"Seg\"`, para segunda-feira.\n"
          },
          "parâmetros": [
            {
              "nome": "numero_dia",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número do dia da semana, de 1 a 7 (use as constantes `DIA_*`)"
            },
            {
              "nome": "caixa_alta",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras maiúsculas"
            },
            {
              "nome": "caixa_baixa",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras minúsculas. Só tem efeito quando `caixa_alta` é `falso`."
            }
          ]
        },
        {
          "nome": "dia_semana_atual",
          "descrição": "Retorna o dia da semana da data atual do computador, de 1 (domingo) a 7 (sábado)",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número do dia da semana, que pode ser comparado com as constantes `DIA_*`. Ex.: 1, para domingo.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "dia_semana_completo",
          "descrição": "Retorna o nome completo do dia da semana correspondente ao número informado, de 1 (domingo) a 7 (sábado).\n\nSe o número estiver fora desse intervalo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o nome completo do dia da semana. Ex.: `\"Segunda-Feira\"`.\n"
          },
          "parâmetros": [
            {
              "nome": "numero_dia",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número do dia da semana, de 1 a 7 (use as constantes `DIA_*`)"
            },
            {
              "nome": "caixa_alta",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras maiúsculas"
            },
            {
              "nome": "caixa_baixa",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras minúsculas. Só tem efeito quando `caixa_alta` é `falso`."
            }
          ]
        },
        {
          "nome": "dia_semana_curto",
          "descrição": "Retorna o nome curto do dia da semana correspondente ao número informado, de 1 (domingo) a 7 (sábado).\n\nSe o número estiver fora desse intervalo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o nome curto do dia da semana. Ex.: `\"Segunda\"`, para segunda-feira.\n"
          },
          "parâmetros": [
            {
              "nome": "numero_dia",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número do dia da semana, de 1 a 7 (use as constantes `DIA_*`)"
            },
            {
              "nome": "caixa_alta",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras maiúsculas"
            },
            {
              "nome": "caixa_baixa",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o nome é retornado todo em letras minúsculas. Só tem efeito quando `caixa_alta` é `falso`."
            }
          ]
        },
        {
          "nome": "hora_atual",
          "descrição": "Retorna a hora atual do computador, no formato de 12 ou de 24 horas",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a hora atual. Ex.: às 22h, retorna 22 no formato de 24 horas e 10 no formato de 12 horas.\n"
          },
          "parâmetros": [
            {
              "nome": "formato_12h",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a hora é retornada no formato de 12 horas (de 0 a 11); se `falso`, no formato de 24 horas (de 0 a 23)"
            }
          ]
        },
        {
          "nome": "mes_atual",
          "descrição": "Retorna o mês da data atual do computador, de 1 (janeiro) a 12 (dezembro)",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número do mês, que pode ser comparado com as constantes `MES_*`. Ex.: 10, para outubro.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "milisegundo_atual",
          "descrição": "Retorna os milissegundos da hora atual do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "os milissegundos, de 0 a 999. Ex.: 426.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "minuto_atual",
          "descrição": "Retorna os minutos da hora atual do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "os minutos, de 0 a 59. Ex.: 45.\n"
          },
          "parâmetros": []
        },
        {
          "nome": "segundo_atual",
          "descrição": "Retorna os segundos da hora atual do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "os segundos, de 0 a 59. Ex.: 32.\n"
          },
          "parâmetros": []
        }
      ]
    },
    {
      "nome": "Graficos",
      "descrição": "Esta biblioteca contém funções para abrir uma janela gráfica e desenhar nela formas geométricas e textos, com cores, gradientes, transparência e rotação",
      "constantes": [
        {
          "nome": "CANAL_B",
          "valor": 2,
          "descrição": "O canal azul (B) de uma cor, para usar em `obter_RGB`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "CANAL_G",
          "valor": 1,
          "descrição": "O canal verde (G) de uma cor, para usar em `obter_RGB`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "CANAL_R",
          "valor": 0,
          "descrição": "O canal vermelho (R) de uma cor, para usar em `obter_RGB`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_AMARELO",
          "valor": -256,
          "descrição": "A cor amarela, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_AZUL",
          "valor": -16776961,
          "descrição": "A cor azul, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_BRANCO",
          "valor": -1,
          "descrição": "A cor branca, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_PRETO",
          "valor": -16777216,
          "descrição": "A cor preta, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_VERDE",
          "valor": -16711936,
          "descrição": "A cor verde, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "COR_VERMELHO",
          "valor": -65536,
          "descrição": "A cor vermelha, para usar em `definir_cor` e `definir_gradiente`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_ABAIXO",
          "valor": 3,
          "descrição": "Direção de gradiente para `definir_gradiente`: da primeira cor, em cima, até a segunda, embaixo\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_ACIMA",
          "valor": 2,
          "descrição": "Direção de gradiente para `definir_gradiente`: da primeira cor, embaixo, até a segunda, em cima\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_DIREITA",
          "valor": 0,
          "descrição": "Direção de gradiente para `definir_gradiente`: da primeira cor, à esquerda, até a segunda, à direita\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_ESQUERDA",
          "valor": 1,
          "descrição": "Direção de gradiente para `definir_gradiente`: da primeira cor, à direita, até a segunda, à esquerda\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_INFERIOR_DIREITO",
          "valor": 4,
          "descrição": "Direção de gradiente para `definir_gradiente`: na diagonal, da primeira cor, no canto superior esquerdo, até a segunda, no canto inferior direito\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_INFERIOR_ESQUERDO",
          "valor": 5,
          "descrição": "Direção de gradiente para `definir_gradiente`: na diagonal, em direção ao canto inferior esquerdo\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_SUPERIOR_DIREITO",
          "valor": 6,
          "descrição": "Direção de gradiente para `definir_gradiente`: na diagonal, da primeira cor, no canto inferior esquerdo, até a segunda, no canto superior direito\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "GRADIENTE_SUPERIOR_ESQUERDO",
          "valor": 7,
          "descrição": "Direção de gradiente para `definir_gradiente`: na diagonal, em direção ao canto superior esquerdo\n",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "altura_imagem",
          "descrição": "Obtém a altura de uma imagem carregada anteriormente",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a altura da imagem, em pixels"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem"
            }
          ]
        },
        {
          "nome": "altura_janela",
          "descrição": "Obtém a altura atual da área de desenho da janela do modo gráfico",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a altura, em pixels"
          },
          "parâmetros": []
        },
        {
          "nome": "altura_tela",
          "descrição": "Obtém a altura da tela do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a altura da tela, em pixels"
          },
          "parâmetros": []
        },
        {
          "nome": "altura_texto",
          "descrição": "Calcula a altura que um texto ocupa ao ser desenhado com a fonte, o tamanho e o estilo atuais",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a altura do texto, em pixels"
          },
          "parâmetros": [
            {
              "nome": "texto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será medido"
            }
          ]
        },
        {
          "nome": "carregar_fonte",
          "descrição": "Carrega uma fonte a partir de um arquivo, para usá-la nos textos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "caminho_fonte",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho do arquivo de fonte no computador"
            }
          ]
        },
        {
          "nome": "carregar_imagem",
          "descrição": "Carrega uma imagem de um arquivo para a memória, para ser usada depois. Os formatos aceitos são JPEG, PNG, BMP e GIF.",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da imagem carregada, usado nas outras funções de imagem"
          },
          "parâmetros": [
            {
              "nome": "caminho",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho do arquivo de imagem no computador"
            }
          ]
        },
        {
          "nome": "criar_cor",
          "descrição": "Cria uma cor a partir da combinação de tons de vermelho, verde e azul (RGB).\n\nSe algum tom estiver fora do intervalo de 0 a 255, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a cor criada, para usar em `definir_cor` e `definir_gradiente`"
          },
          "parâmetros": [
            {
              "nome": "vermelho",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a intensidade do vermelho, de 0 a 255"
            },
            {
              "nome": "verde",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a intensidade do verde, de 0 a 255"
            },
            {
              "nome": "azul",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a intensidade do azul, de 0 a 255"
            }
          ]
        },
        {
          "nome": "definir_cor",
          "descrição": "Define a cor atual do modo gráfico. Ela é usada nos desenhos feitos a partir de então (formas e textos) e no fundo, ao chamar `limpar`. Substitui o gradiente definido com `definir_gradiente`.",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "cor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a nova cor: uma das constantes `COR_*` ou uma cor criada com `criar_cor`\n"
            }
          ]
        },
        {
          "nome": "definir_dimensoes_janela",
          "descrição": "Altera o tamanho da área de desenho da janela do modo gráfico",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a nova largura, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a nova altura, em pixels"
            }
          ]
        },
        {
          "nome": "definir_estilo_texto",
          "descrição": "Define o estilo da fonte usada para desenhar os textos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "italico",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o texto é desenhado em itálico"
            },
            {
              "nome": "negrito",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o texto é desenhado em negrito"
            },
            {
              "nome": "sublinhado",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o texto é desenhado sublinhado"
            }
          ]
        },
        {
          "nome": "definir_fonte_texto",
          "descrição": "Define a fonte usada para desenhar os textos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "nome",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da fonte (ex.: Arial, Times New Roman, Tahoma). Se a fonte não estiver instalada no computador, é usada uma fonte padrão.\n"
            }
          ]
        },
        {
          "nome": "definir_gradiente",
          "descrição": "Define como cor atual um gradiente, ou seja, uma transição suave entre duas cores. Ele é usado nos desenhos feitos a partir de então (formas e textos) e no fundo, ao chamar `limpar`. Em cada desenho, o gradiente vai de um lado ao outro da forma desenhada.",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "tipo",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a direção do gradiente: uma das constantes `GRADIENTE_*`\n"
            },
            {
              "nome": "cor1",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a cor em que o gradiente começa"
            },
            {
              "nome": "cor2",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a cor em que o gradiente termina"
            }
          ]
        },
        {
          "nome": "definir_icone_janela",
          "descrição": "Altera o ícone da janela do modo gráfico, que aparece ao lado do título e na barra de tarefas do sistema operacional",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será usada como ícone"
            }
          ]
        },
        {
          "nome": "definir_opacidade",
          "descrição": "Define a opacidade dos desenhos: quanto menor o valor, mais transparente fica o desenho. Com ela, é possível fazer desenhos semitransparentes, através dos quais se vê o que está atrás.\n\nA opacidade vale para todos os desenhos feitos depois da chamada. Se um retângulo e uma elipse forem desenhados em seguida, os dois ficarão com a mesma opacidade. Para mudar só a do retângulo, chame a função de novo com o valor 255 antes de desenhar a elipse.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "opacidade",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o nível de opacidade, de 0 (totalmente transparente) a 255 (totalmente opaco). Fora desse intervalo, ocorre um erro de execução."
            }
          ]
        },
        {
          "nome": "definir_quadro_gif",
          "descrição": "Define qual quadro de um GIF é o atual",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            },
            {
              "nome": "quadro",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número do quadro que passará a ser o atual"
            }
          ]
        },
        {
          "nome": "definir_rotacao",
          "descrição": "Define a rotação dos desenhos, que é feita em torno do centro de cada desenho. Vale para textos e formas, como linhas, retângulos e elipses.\n\nA rotação vale para todos os desenhos feitos depois da chamada. Se um retângulo e uma elipse forem desenhados em seguida, os dois ficarão girados no mesmo ângulo. Para girar só o retângulo, chame a função de novo com o valor 0 antes de desenhar a elipse.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "rotacao",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o ângulo de rotação, em graus. 0 e os múltiplos de 360 indicam que não há rotação; valores positivos giram no sentido horário, e negativos, no sentido anti-horário"
            }
          ]
        },
        {
          "nome": "definir_tamanho_texto",
          "descrição": "Define o tamanho da fonte usada para desenhar os textos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "tamanho",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o tamanho da fonte, em pixels"
            }
          ]
        },
        {
          "nome": "definir_titulo_janela",
          "descrição": "Define o título exibido no alto da janela do modo gráfico",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "titulo",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o novo título da janela"
            }
          ]
        },
        {
          "nome": "desenhar_elipse",
          "descrição": "Desenha uma elipse (ou um círculo, se `largura` e `altura` forem iguais) dentro de um retângulo imaginário com o canto superior esquerdo na posição `x` e `y` e com o tamanho definido por `largura` e `altura`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do canto superior esquerdo do retângulo que contém a elipse, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do canto superior esquerdo do retângulo que contém a elipse, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a largura da elipse, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a altura da elipse, em pixels"
            },
            {
              "nome": "preencher",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a elipse é preenchida com a cor atual; se `falso`, só o contorno é desenhado"
            }
          ]
        },
        {
          "nome": "desenhar_imagem",
          "descrição": "Desenha uma imagem carregada anteriormente, com o canto superior esquerdo na posição `x` e `y`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal da imagem, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical da imagem, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será desenhada"
            }
          ]
        },
        {
          "nome": "desenhar_linha",
          "descrição": "Desenha uma linha reta do ponto A (`x1`, `y1`) até o ponto B (`x2`, `y2`)",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x1",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do ponto A, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y1",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do ponto A, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "x2",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do ponto B, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y2",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do ponto B, em pixels, contada a partir do topo da janela"
            }
          ]
        },
        {
          "nome": "desenhar_poligono",
          "descrição": "Desenha um polígono ligando os pontos informados, na ordem em que aparecem na matriz, e ligando o último ponto ao primeiro",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "pontos",
              "tipo": {
                "primitivo": "inteiro",
                "dimensão": "matriz"
              },
              "descrição": "uma matriz com uma linha para cada vértice do polígono, com a coordenada `x` na coluna 0 e a `y` na coluna 1, em pixels"
            },
            {
              "nome": "preencher",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o polígono é preenchido com a cor atual; se `falso`, só o contorno é desenhado"
            }
          ]
        },
        {
          "nome": "desenhar_ponto",
          "descrição": "Desenha um ponto, do tamanho de um pixel, na posição `x` e `y`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do ponto, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do ponto, em pixels, contada a partir do topo da janela"
            }
          ]
        },
        {
          "nome": "desenhar_porcao_imagem",
          "descrição": "Desenha uma parte de uma imagem carregada anteriormente, com o canto superior esquerdo na posição `x` e `y`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal onde a parte da imagem será desenhada, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical onde a parte da imagem será desenhada, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "xi",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal, dentro da imagem, onde começa a parte que será desenhada"
            },
            {
              "nome": "yi",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical, dentro da imagem, onde começa a parte que será desenhada"
            },
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a largura da parte que será desenhada, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a altura da parte que será desenhada, em pixels"
            },
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será desenhada"
            }
          ]
        },
        {
          "nome": "desenhar_quadro_atual_gif",
          "descrição": "Desenha o quadro atual de um GIF carregado anteriormente, com o canto superior esquerdo na posição `x` e `y`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do GIF, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do GIF, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            }
          ]
        },
        {
          "nome": "desenhar_retangulo",
          "descrição": "Desenha um retângulo com o canto superior esquerdo na posição `x` e `y` e com o tamanho definido por `largura` e `altura`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do canto superior esquerdo do retângulo, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do canto superior esquerdo do retângulo, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a largura do retângulo, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a altura do retângulo, em pixels"
            },
            {
              "nome": "arredondar_cantos",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o retângulo é desenhado com os cantos arredondados"
            },
            {
              "nome": "preencher",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o retângulo é preenchido com a cor atual; se `falso`, só o contorno é desenhado"
            }
          ]
        },
        {
          "nome": "desenhar_texto",
          "descrição": "Desenha um texto na posição `x` e `y`, com a cor, a fonte, o tamanho e o estilo atuais",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal do texto, em pixels, contada a partir da borda esquerda da janela"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical do texto, em pixels, contada a partir do topo da janela"
            },
            {
              "nome": "texto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será desenhado"
            }
          ]
        },
        {
          "nome": "encerrar_modo_grafico",
          "descrição": "Encerra o modo gráfico e fecha a janela aberta por `iniciar_modo_grafico`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "entrar_modo_tela_cheia",
          "descrição": "Amplia a janela do modo gráfico para que ela ocupe a tela inteira",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "exibir_borda_janela",
          "descrição": "Exibe novamente a borda da janela do modo gráfico, se ela tiver sido ocultada com `ocultar_borda_janela`",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "fechar_janela",
          "descrição": "Fecha a janela do modo gráfico, como se o usuário tivesse clicado no botão de fechar",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "iniciar_modo_grafico",
          "descrição": "Inicia o modo gráfico e abre a janela onde os desenhos são exibidos.\n\nAs outras funções de janela e de desenho só podem ser usadas depois dela; antes, causam um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "manter_visivel",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "define se a janela do modo gráfico deve ficar sempre visível sobre as outras janelas (útil durante a depuração)"
            }
          ]
        },
        {
          "nome": "largura_imagem",
          "descrição": "Obtém a largura de uma imagem carregada anteriormente",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a largura da imagem, em pixels"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem"
            }
          ]
        },
        {
          "nome": "largura_janela",
          "descrição": "Obtém a largura atual da área de desenho da janela do modo gráfico",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a largura, em pixels"
          },
          "parâmetros": []
        },
        {
          "nome": "largura_tela",
          "descrição": "Obtém a largura da tela do computador",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a largura da tela, em pixels"
          },
          "parâmetros": []
        },
        {
          "nome": "largura_texto",
          "descrição": "Calcula a largura que um texto ocupa ao ser desenhado com a fonte, o tamanho e o estilo atuais",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a largura do texto, em pixels"
          },
          "parâmetros": [
            {
              "nome": "texto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será medido"
            }
          ]
        },
        {
          "nome": "liberar_imagem",
          "descrição": "Libera a memória ocupada por uma imagem carregada anteriormente",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem"
            }
          ]
        },
        {
          "nome": "limpar",
          "descrição": "Apaga todos os desenhos e pinta o fundo da janela com a cor (ou o gradiente) atual",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "minimizar_janela",
          "descrição": "Minimiza a janela do modo gráfico, como se o usuário tivesse clicado no botão de minimizar",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "obter_cor_pixel",
          "descrição": "Obtém a cor de um pixel de uma imagem carregada com `carregar_imagem`",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a cor do pixel"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem"
            },
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a coluna do pixel na imagem"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a linha do pixel na imagem"
            }
          ]
        },
        {
          "nome": "obter_intervalo_gif",
          "descrição": "Obtém o intervalo entre os quadros de um GIF",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o intervalo do quadro atual, em milissegundos"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            }
          ]
        },
        {
          "nome": "obter_numero_quadro_atual_gif",
          "descrição": "Obtém o número do quadro atual de um GIF",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número do quadro atual"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            }
          ]
        },
        {
          "nome": "obter_numero_quadros_gif",
          "descrição": "Obtém o número de quadros de um GIF",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de quadros do GIF"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            }
          ]
        },
        {
          "nome": "obter_quadro_gif",
          "descrição": "Obtém um quadro de um GIF como uma imagem separada",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da imagem com o quadro"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            },
            {
              "nome": "quadro",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número do quadro desejado"
            }
          ]
        },
        {
          "nome": "obter_RGB",
          "descrição": "Obtém o valor de um dos canais (vermelho, verde ou azul) de uma cor",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o valor do canal, de 0 a 255. Para um canal inválido, retorna 0."
          },
          "parâmetros": [
            {
              "nome": "cor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a cor da qual será obtido o canal"
            },
            {
              "nome": "canal",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o canal desejado: `CANAL_R` (vermelho), `CANAL_G` (verde) ou `CANAL_B` (azul)\n"
            }
          ]
        },
        {
          "nome": "ocultar_borda_janela",
          "descrição": "Oculta a borda da janela do modo gráfico, deixando visível só o conteúdo dela",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "proximo_frame_gif",
          "descrição": "Avança a animação de um GIF para o próximo quadro",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do GIF"
            }
          ]
        },
        {
          "nome": "redimensionar_imagem",
          "descrição": "Cria uma cópia de uma imagem carregada com `carregar_imagem`, com outro tamanho.\n\nSe a largura ou a altura for 0, ela é calculada a partir da outra, mantendo a proporção da imagem.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da nova imagem"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será redimensionada"
            },
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a nova largura da imagem, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a nova altura da imagem, em pixels"
            },
            {
              "nome": "manter_qualidade",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, o redimensionamento preserva melhor a qualidade da imagem"
            }
          ]
        },
        {
          "nome": "renderizar",
          "descrição": "Exibe na janela tudo o que foi desenhado desde a última chamada desta função.\n\nAs funções de desenho não desenham direto na tela: elas acumulam os desenhos em uma área reservada da memória, e a tela só é atualizada de uma vez quando `renderizar` é chamada. Essa técnica, chamada de **Double Buffer**, deixa o programa mais rápido e evita que a imagem pisque.\n\nPor isso, chame esta função depois de todas as outras funções de desenho, para garantir que os desenhos apareçam.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [],
          "referência": "http://en.wikipedia.org/wiki/Multiple_buffering#Double_buffering_in_computer_graphics"
        },
        {
          "nome": "renderizar_imagem",
          "descrição": "Cria uma nova imagem na memória e desenha nela o conteúdo do modo gráfico, em vez de desenhá-lo na tela",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da nova imagem"
          },
          "parâmetros": [
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a largura da nova imagem, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a altura da nova imagem, em pixels"
            }
          ]
        },
        {
          "nome": "restaurar_janela",
          "descrição": "Restaura a janela do modo gráfico depois de minimizada, como se o usuário tivesse clicado no ícone do programa na barra de tarefas do sistema operacional",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "sair_modo_tela_cheia",
          "descrição": "Volta a janela do modo gráfico ao tamanho que ela tinha antes de entrar no modo de tela cheia",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "salvar_imagem",
          "descrição": "Salva uma imagem em um arquivo",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será salva"
            },
            {
              "nome": "caminho",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho do arquivo onde a imagem será salva"
            }
          ]
        },
        {
          "nome": "transformar_imagem",
          "descrição": "Cria uma cópia transformada de uma imagem carregada com `carregar_imagem`. As transformações possíveis são espelhamento, rotação e remoção de cor.\n\nO espelhamento inverte a imagem na horizontal, na vertical ou nas duas direções.\n\nA rotação gira a imagem em qualquer ângulo.\n\nA remoção de cor torna transparente uma cor escolhida da imagem.\n\nA imagem original não é alterada: o resultado fica em uma nova imagem, em outro endereço de memória.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da nova imagem"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será transformada"
            },
            {
              "nome": "espelhamento_horizontal",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a imagem é espelhada na horizontal"
            },
            {
              "nome": "espelhamento_vertical",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a imagem é espelhada na vertical"
            },
            {
              "nome": "rotacao",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o ângulo de rotação, em graus. Com 0, a imagem não é girada. Ao girar a imagem, a largura e a altura dela podem mudar."
            },
            {
              "nome": "cor_transparente",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a cor que se tornará transparente. Com 0, nenhuma cor é removida."
            }
          ]
        },
        {
          "nome": "transformar_porcao_imagem",
          "descrição": "Cria uma cópia transformada de uma parte de uma imagem carregada com `carregar_imagem`. As transformações possíveis são espelhamento, rotação e remoção de cor.\n\nO espelhamento inverte a parte da imagem na horizontal, na vertical ou nas duas direções.\n\nA rotação gira a parte da imagem em qualquer ângulo.\n\nA remoção de cor torna transparente uma cor escolhida da imagem.\n\nA imagem original não é alterada: o resultado fica em uma nova imagem, em outro endereço de memória.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço da nova imagem"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço da imagem que será transformada"
            },
            {
              "nome": "x",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição horizontal, dentro da imagem, onde começa a parte que será transformada"
            },
            {
              "nome": "y",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição vertical, dentro da imagem, onde começa a parte que será transformada"
            },
            {
              "nome": "largura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a largura da parte que será transformada, em pixels"
            },
            {
              "nome": "altura",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a altura da parte que será transformada, em pixels"
            },
            {
              "nome": "espelhamento_horizontal",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a imagem é espelhada na horizontal"
            },
            {
              "nome": "espelhamento_vertical",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "se `verdadeiro`, a imagem é espelhada na vertical"
            },
            {
              "nome": "rotacao",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o ângulo de rotação, em graus. Com 0, a imagem não é girada. Ao girar a imagem, a largura e a altura dela podem mudar."
            },
            {
              "nome": "cor_transparente",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a cor que se tornará transparente. Com 0, nenhuma cor é removida."
            }
          ]
        }
      ]
    },
    {
      "nome": "Internet",
      "descrição": "Esta biblioteca contém diversas funções de conexão com a web",
      "constantes": [],
      "funções": [
        {
          "nome": "baixar_imagem",
          "descrição": "Obtém recursos de uma página web",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "O tipo da Imagem"
          },
          "parâmetros": [
            {
              "nome": "endereço",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o endereço de onde o conteúdo deverá ser obtido"
            },
            {
              "nome": "caminho",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho de onde o conteúdo deverá ser salvo"
            }
          ]
        },
        {
          "nome": "definir_tempo_limite",
          "descrição": "Define um valor de tempo limite de espera",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "tempo",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o tempo limite de espera em milisegundos"
            }
          ]
        },
        {
          "nome": "endereco_disponivel",
          "descrição": "Verifica a disponibilidade atual de algum endereço",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o endereço estiver disponível no momento, `falso` se não\n"
          },
          "parâmetros": [
            {
              "nome": "endereço",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o endereço de onde o conteúdo deverá ser obtido"
            }
          ]
        },
        {
          "nome": "obter_texto",
          "descrição": "Obtém o conteúdo de uma página web",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "O conteúdo de uma página web"
          },
          "parâmetros": [
            {
              "nome": "caminho",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho de onde o conteúdo deverá ser obtido"
            }
          ]
        }
      ]
    },
    {
      "nome": "Matematica",
      "descrição": "Esta biblioteca contém as funções matemáticas mais comuns, como potência, raiz, arredondamento e trigonometria",
      "constantes": [
        {
          "nome": "PI",
          "valor": 3.141592653589793,
          "descrição": "A constante matemática π (pi): a razão entre o perímetro de uma circunferência e o seu diâmetro\n",
          "tipo": {
            "primitivo": "real"
          },
          "referência": "https://pt.wikipedia.org/wiki/Pi"
        }
      ],
      "funções": [
        {
          "nome": "arredondar",
          "descrição": "Arredonda um número `real` para a quantidade de casas decimais informada.\n\nSe o primeiro dígito descartado for 5 ou mais, o número é arredondado para cima; se for menor que 5, para baixo.\n",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o número arredondado"
          },
          "parâmetros": [
            {
              "nome": "numero",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o número que será arredondado"
            },
            {
              "nome": "casas",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a quantidade de casas decimais que o resultado terá. Com 0, o número é arredondado para um valor inteiro."
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Arredondamento"
        },
        {
          "nome": "cosseno",
          "descrição": "Calcula o cosseno de um ângulo informado em radianos",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o cosseno do ângulo, entre -1 e 1"
          },
          "parâmetros": [
            {
              "nome": "angulo",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o ângulo, em radianos. Para converter graus em radianos, multiplique por `PI` e divida por 180."
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Cosseno"
        },
        {
          "nome": "logaritmo",
          "descrição": "Calcula o logaritmo de um número na base informada",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o logaritmo de `numero` na `base` informada, ou seja, o expoente ao qual a `base` deve ser elevada para resultar em `numero`"
          },
          "parâmetros": [
            {
              "nome": "numero",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o número do qual será calculado o logaritmo (o logaritmando)"
            },
            {
              "nome": "base",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "a base do logaritmo"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Logaritmo"
        },
        {
          "nome": "maior_numero",
          "descrição": "Retorna o maior entre dois números",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o maior dos dois números"
          },
          "parâmetros": [
            {
              "nome": "numeroA",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o primeiro número a ser comparado"
            },
            {
              "nome": "numeroB",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o segundo número a ser comparado"
            }
          ]
        },
        {
          "nome": "menor_numero",
          "descrição": "Retorna o menor entre dois números",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o menor dos dois números"
          },
          "parâmetros": [
            {
              "nome": "numeroA",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o primeiro número a ser comparado"
            },
            {
              "nome": "numeroB",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o segundo número a ser comparado"
            }
          ]
        },
        {
          "nome": "potencia",
          "descrição": "Calcula a potência de um número, ou seja, a `base` elevada ao `expoente`",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "a `base` elevada ao `expoente`"
          },
          "parâmetros": [
            {
              "nome": "base",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o número que será elevado ao expoente"
            },
            {
              "nome": "expoente",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o expoente, que pode ser negativo ou fracionário. Ex.: com expoente 2, a base é multiplicada por ela mesma.\n"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Exponencia%C3%A7%C3%A3o"
        },
        {
          "nome": "raiz",
          "descrição": "Calcula a raiz de um número com o índice informado (quadrada, cúbica etc.)",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "a raiz do `radicando` com o `indice` informado"
          },
          "parâmetros": [
            {
              "nome": "radicando",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o número do qual será extraída a raiz"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o índice da raiz. Com índice 2, calcula a raiz quadrada; com índice 3, a raiz cúbica; e assim por diante."
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Radicia%C3%A7%C3%A3o"
        },
        {
          "nome": "seno",
          "descrição": "Calcula o seno de um ângulo informado em radianos",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o seno do ângulo, entre -1 e 1"
          },
          "parâmetros": [
            {
              "nome": "angulo",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o ângulo, em radianos. Para converter graus em radianos, multiplique por `PI` e divida por 180."
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Seno"
        },
        {
          "nome": "tangente",
          "descrição": "Calcula a tangente de um ângulo informado em radianos",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "a tangente do ângulo"
          },
          "parâmetros": [
            {
              "nome": "angulo",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o ângulo, em radianos. Para converter graus em radianos, multiplique por `PI` e divida por 180."
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Tangente"
        },
        {
          "nome": "valor_absoluto",
          "descrição": "Calcula o valor absoluto (módulo) de um número, ou seja, o número sem o sinal",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o valor absoluto do número, que nunca é negativo"
          },
          "parâmetros": [
            {
              "nome": "numero",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o número do qual será calculado o valor absoluto"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Fun%C3%A7%C3%A3o_modular"
        }
      ]
    },
    {
      "nome": "Mouse",
      "descrição": "Esta biblioteca contém um conjunto de funções para manipular a entrada de dados através do mouse do computador. **IMPORTANTE:** Esta biblioteca não funciona no console de entrada e saída de dados do Portugol Studio, ela só funciona com a biblioteca Graficos, se o modo gráfico estiver iniciado.",
      "constantes": [
        {
          "nome": "BOTAO_DIREITO",
          "valor": 1,
          "descrição": "Código numérico do botão direito do mouse",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "BOTAO_ESQUERDO",
          "valor": 0,
          "descrição": "Código numérico do botão esquerdo do mouse",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "BOTAO_MEIO",
          "valor": 2,
          "descrição": "Código numérico do botão do meio do mouse",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "algum_botao_pressionado",
          "descrição": "Testa se existe algum botão do mouse pressionado neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o resultado do teste. `verdadeiro` se houver um botão do mouse pressionado no momento do teste. Caso contrário, retorna `falso`"
          },
          "parâmetros": []
        },
        {
          "nome": "botao_pressionado",
          "descrição": "Testa se um determinado `botão` do mouse está pressionado neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o resultado do teste. `verdadeiro` se o `botão` estiver pressionado no momento do teste. Caso contrário, retorna `falso`"
          },
          "parâmetros": [
            {
              "nome": "botao",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o código do botão que será testado"
            }
          ]
        },
        {
          "nome": "exibir_cursor",
          "descrição": "Exibe novamente o cursor do mouse caso ele esteja oculto",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "ler_botao",
          "descrição": "Aguarda até que um botão seja clicado (isto é, foi pressionado e depois solto), e captura o seu código",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o código do botão lido"
          },
          "parâmetros": []
        },
        {
          "nome": "ocultar_cursor",
          "descrição": "Oculta o cursor do mouse",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "posicao_x",
          "descrição": "Obtém a coordenada X do mouse neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a coordenada X do mouse neste instante"
          },
          "parâmetros": []
        },
        {
          "nome": "posicao_y",
          "descrição": "Obtém a coordenada Y do mouse neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a coordenada Y do mouse neste instante"
          },
          "parâmetros": []
        }
      ]
    },
    {
      "nome": "Objetos",
      "descrição": "Esta biblioteca contém funções para criar objetos (conjuntos de propriedades com nome e valor), inclusive a partir de textos JSON e XML, e para ler e alterar as suas propriedades",
      "constantes": [
        {
          "nome": "TIPO_CADEIA",
          "valor": 2,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é do tipo `cadeia`. Uma `cadeia` com um só caractere resulta em `TIPO_CARACTER`.",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_CARACTER",
          "valor": 3,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é uma `cadeia` com um só caractere",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_INTEIRO",
          "valor": 1,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é do tipo `inteiro`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_LOGICO",
          "valor": 5,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é do tipo `logico`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_OBJETO",
          "valor": 6,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é outro objeto",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_REAL",
          "valor": 4,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é do tipo `real`",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TIPO_VETOR",
          "valor": 7,
          "descrição": "Valor retornado por `tipo_propriedade` quando a propriedade é um vetor",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "atribuir_propriedade",
          "descrição": "Atribui um valor a uma propriedade do objeto. Se a propriedade não existir, ela é criada.",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que receberá o valor"
            },
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "*"
              },
              "descrição": "o valor que será atribuído à propriedade, do tipo `inteiro`, `real`, `cadeia`, `caracter` ou `logico`"
            }
          ]
        },
        {
          "nome": "contem_propriedade",
          "descrição": "Verifica se o objeto tem a propriedade informada",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o objeto tiver a propriedade; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade procurada"
            }
          ]
        },
        {
          "nome": "criar_objeto",
          "descrição": "Cria um objeto vazio, sem nenhuma propriedade",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço do novo objeto, usado nas outras funções da biblioteca"
          },
          "parâmetros": []
        },
        {
          "nome": "criar_objeto_via_json",
          "descrição": "Cria um objeto a partir de um texto no formato JSON (JavaScript Object Notation)",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço do novo objeto, usado nas outras funções da biblioteca"
          },
          "parâmetros": [
            {
              "nome": "json",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto no formato JSON que descreve o objeto"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/JSON"
        },
        {
          "nome": "criar_objeto_via_xml",
          "descrição": "Cria um objeto a partir de um texto no formato XML (eXtensible Markup Language)",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço do novo objeto, usado nas outras funções da biblioteca"
          },
          "parâmetros": [
            {
              "nome": "xml",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto no formato XML que descreve o objeto"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/XML"
        },
        {
          "nome": "liberar",
          "descrição": "Remove da memória todos os objetos criados até o momento",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": []
        },
        {
          "nome": "liberar_objeto",
          "descrição": "Remove da memória o objeto do endereço informado.\n\nOs endereços dos objetos criados depois dele diminuem em 1.\n",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            }
          ]
        },
        {
          "nome": "obter_json",
          "descrição": "Obtém o texto no formato JSON (JavaScript Object Notation) que representa o objeto inteiro, com todas as suas propriedades",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o texto no formato JSON que representa o objeto"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/JSON"
        },
        {
          "nome": "obter_propriedade_tipo_cadeia",
          "descrição": "Obtém o valor de uma propriedade do tipo `cadeia` do objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o valor da propriedade"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_cadeia_em_vetor",
          "descrição": "Obtém um elemento do tipo `cadeia` de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o valor do elemento"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_caracter",
          "descrição": "Obtém o primeiro caractere de uma propriedade do tipo `cadeia` do objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o primeiro caractere do valor da propriedade"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_caracter_em_vetor",
          "descrição": "Obtém o primeiro caractere de um elemento do tipo `cadeia` de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o primeiro caractere do elemento"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_inteiro",
          "descrição": "Obtém o valor de uma propriedade do tipo `inteiro` do objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o valor da propriedade"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_inteiro_em_vetor",
          "descrição": "Obtém um elemento do tipo `inteiro` de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o valor do elemento"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_logico",
          "descrição": "Obtém o valor de uma propriedade do tipo `logico` do objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o valor da propriedade"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_logico_em_vetor",
          "descrição": "Obtém um elemento do tipo `logico` de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o valor do elemento"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_objeto",
          "descrição": "Obtém um objeto guardado em uma propriedade de outro objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço do objeto obtido, para usar nas outras funções da biblioteca"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_objeto_em_vetor",
          "descrição": "Obtém o objeto que está em uma posição de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço do objeto obtido, para usar nas outras funções da biblioteca"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_real",
          "descrição": "Obtém o valor de uma propriedade do tipo `real` do objeto.\n\nSe o objeto não tiver a propriedade, ou se ela for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o valor da propriedade"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade cujo valor será obtido"
            }
          ]
        },
        {
          "nome": "obter_propriedade_tipo_real_em_vetor",
          "descrição": "Obtém um elemento do tipo `real` de um vetor guardado em uma propriedade do objeto.\n\nSe a propriedade não for um vetor, se o índice não existir no vetor ou se o elemento for de outro tipo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o valor do elemento"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do elemento no vetor, começando em 0"
            }
          ]
        },
        {
          "nome": "obter_tamanho_vetor_propriedade",
          "descrição": "Obtém o número de elementos de um vetor guardado em uma propriedade do objeto",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de elementos do vetor"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade que contém o vetor"
            }
          ]
        },
        {
          "nome": "tipo_propriedade",
          "descrição": "Identifica o tipo do valor de uma propriedade do objeto.\n\nSe o objeto não tiver a propriedade, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "uma das constantes `TIPO_*` (por exemplo, `TIPO_INTEIRO`), ou 0 se o tipo não for nenhum deles"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço do objeto"
            },
            {
              "nome": "propriedade",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o nome da propriedade"
            }
          ]
        }
      ]
    },
    {
      "nome": "ServicosWeb",
      "descrição": "Esta biblioteca contém uma série de funções para trabalhar com serviços web",
      "constantes": [
        {
          "nome": "ATUALIZAR",
          "valor": 3,
          "descrição": "Constante para definir o método HTTP PUT",
          "tipo": {
            "primitivo": "inteiro"
          },
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#PUT"
        },
        {
          "nome": "EXCLUIR",
          "valor": 4,
          "descrição": "Constante para definir o método HTTP DELETE",
          "tipo": {
            "primitivo": "inteiro"
          },
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#DELETE"
        },
        {
          "nome": "OBTER",
          "valor": 1,
          "descrição": "Constante para definir o método HTTP GET",
          "tipo": {
            "primitivo": "inteiro"
          },
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#GET"
        },
        {
          "nome": "PUBLICAR",
          "valor": 2,
          "descrição": "Constante para definir o método HTTP POST",
          "tipo": {
            "primitivo": "inteiro"
          },
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#POST"
        }
      ],
      "funções": [
        {
          "nome": "abrir_conexao",
          "descrição": "Abre uma conexão customizável com o endereço especificado",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "endereço para o qual a requisição será feita"
            }
          ]
        },
        {
          "nome": "adicionar_cabecalho",
          "descrição": "Adiciona um cabeçalho na conexão customizável, para utilizar esta função é necessário abrir uma conexão antes",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "chave",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "chave do cabeçalho que será incluído na conexão"
            },
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "valor do cabeçalho que será incluído na conexão"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Lista_de_campos_de_cabe%C3%A7alho_HTTP"
        },
        {
          "nome": "adicionar_parametros",
          "descrição": "Adiciona um objeto no formato JSON na conexão customizável, para utilizar esta função é necessário abrir uma conexão antes. Esta função deve ser utilizada para informar os parâmetros dos métodos HTTP POST e PUT",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "objeto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "objeto no formato JSON passado por parâmetro no corpo da requisição"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol"
        },
        {
          "nome": "atualizar_dados",
          "descrição": "Realiza uma chamada HTTP PUT para o endereço especificado, retornando uma cadeia no formato JSON como resposta",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a cadeia JSON contendo a resposta da requisição"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "endereço para o qual a requisição será feita"
            },
            {
              "nome": "objeto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "objeto no formato JSON passado por parâmetro no corpo da requisição"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#PUT"
        },
        {
          "nome": "excluir_dados",
          "descrição": "Realiza uma chamada HTTP DELETE para o endereço especificado, retornando uma cadeia no formato JSON como resposta",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a cadeia JSON contendo a resposta da requisição"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "endereço para o qual a requisição será feita"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#DELETE"
        },
        {
          "nome": "fazer_requisicao",
          "descrição": "Realiza uma chamada HTTP através de uma conexão customizada, retornando uma cadeia no formato JSON como resposta",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a cadeia JSON contendo a resposta da requisição"
          },
          "parâmetros": [
            {
              "nome": "metodoHttp",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "Método HTTP que será utilizado nesta execução (GET, POST, PUT ou DELETE)"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol"
        },
        {
          "nome": "obter_dados",
          "descrição": "Realiza uma chamada HTTP GET para o endereço especificado, retornando uma cadeia no formato JSON como resposta",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a cadeia JSON contendo a resposta da requisição"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "endereço para o qual a requisição será feita"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#GET"
        },
        {
          "nome": "publicar_dados",
          "descrição": "Realiza uma chamada HTTP POST para o endereço especificado, retornando uma cadeia no formato JSON como resposta",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a cadeia JSON contendo a resposta da requisição"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "endereço para o qual a requisição será feita"
            },
            {
              "nome": "objeto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "objeto no formato JSON passado por parâmetro no corpo da requisição"
            }
          ],
          "referência": "https://pt.wikipedia.org/wiki/Hypertext_Transfer_Protocol#POST"
        }
      ]
    },
    {
      "nome": "Sons",
      "descrição": "Esta biblioteca contém funções que permitem reproduzir sons dentro de um programa. No momento, somente o formato MP3 é suportado.",
      "constantes": [],
      "funções": [
        {
          "nome": "carregar_som",
          "descrição": "Carrega um som na memória para ser reproduzido mais tarde",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço de memória no qual o som foi carregado"
          },
          "parâmetros": [
            {
              "nome": "caminho_som",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o caminho para o arquivo de som no sistema de arquivos"
            }
          ]
        },
        {
          "nome": "definir_posicao_atual_musica",
          "descrição": "Define a posição atual da música em milisegundos",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer alterar o volume"
            },
            {
              "nome": "milissegundos",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o tempo em milissegundos que deseja colocar a musica"
            }
          ]
        },
        {
          "nome": "definir_volume",
          "descrição": "Define o volume geral",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "volume",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "O novo volume geral (entre 0 e 100)"
            }
          ]
        },
        {
          "nome": "definir_volume_reproducao",
          "descrição": "Define um novo volume para um som que já está sendo executado",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer alterar o volume"
            },
            {
              "nome": "volume",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o novo volume entre 0 e 100"
            }
          ]
        },
        {
          "nome": "interromper_som",
          "descrição": "Interrompe uma reprodução específica de um som que está sendo executada no momento",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer interromper"
            }
          ]
        },
        {
          "nome": "liberar_som",
          "descrição": "Libera a memória utilizada por um som que tenha sido previamente carregado. Se o som estiver sendo reproduzido, todas as reproduções deste som serão interrompidas",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do som"
            }
          ]
        },
        {
          "nome": "obter_posicao_atual_musica",
          "descrição": "Obtêm a posição atual da música em milisegundos",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o tempo atual em milissegundos do som"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer alterar o volume"
            }
          ]
        },
        {
          "nome": "obter_tamanho_musica",
          "descrição": "Obtêm o tamanho da música em milisegundos",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "tempo total em milissegundos do som"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer alterar o volume"
            }
          ]
        },
        {
          "nome": "obter_volume",
          "descrição": "Retorna o volume geral",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "Um valor do tipo inteiro entre 0 e 100 representando o volume geral atual."
          },
          "parâmetros": []
        },
        {
          "nome": "obter_volume_reproducao",
          "descrição": "Retornar o volume de uma reprodução de som",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "Um valor do tipo inteiro entre 0 e 100 representando o volume atual da reprodução. Caso a reprodução não exista ou já tenha sido finalizada o valor -1 será retornado"
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "O endereço de memória da reprodução que se quer obter o volume"
            }
          ]
        },
        {
          "nome": "pausar_som",
          "descrição": "Pausa uma reprodução específica de um som que está sendo executada no momento",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória da reprodução que se quer interromper"
            }
          ]
        },
        {
          "nome": "reproduzir_som",
          "descrição": "Reproduz um som previamente carregado na memória. O som é reproduzido de forma assíncrona, ou seja, o som ficará reproduzindo no fundo, enquanto o programa executa as próximas instruções normalmente. Um mesmo som pode ser reproduzido várias vezes e pode se sobrepor a outros sons.",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o endereço de memória da reprodução de som. Este endereço é utilizado quando se deseja interromper esta reprodução de som especificamente."
          },
          "parâmetros": [
            {
              "nome": "endereco",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o endereço de memória do som a ser reproduzido"
            },
            {
              "nome": "repetir",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "determina se o som deve ficar repetindo até ser manualmente interrompido"
            }
          ]
        }
      ]
    },
    {
      "nome": "Teclado",
      "descrição": "Esta biblioteca contém um conjunto de funções para manipular a entrada de dados através do teclado do computador. **IMPORTANTE:** Esta biblioteca não funciona no console de entrada e saída de dados do Portugol Studio, ela só funciona com a biblioteca Graficos, se o modo gráfico estiver iniciado.",
      "constantes": [
        {
          "nome": "TECLA_0",
          "valor": 48,
          "descrição": "Código numérico da tecla '0' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_0_NUM",
          "valor": 96,
          "descrição": "Código numérico da tecla '0' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_1",
          "valor": 49,
          "descrição": "Código numérico da tecla '1' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_1_NUM",
          "valor": 97,
          "descrição": "Código numérico da tecla '1' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_2",
          "valor": 50,
          "descrição": "Código numérico da tecla '2' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_2_NUM",
          "valor": 98,
          "descrição": "Código numérico da tecla '2' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_3",
          "valor": 51,
          "descrição": "Código numérico da tecla '3' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_3_NUM",
          "valor": 99,
          "descrição": "Código numérico da tecla '3' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_4",
          "valor": 52,
          "descrição": "Código numérico da tecla '4' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_4_NUM",
          "valor": 100,
          "descrição": "Código numérico da tecla '4' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_5",
          "valor": 53,
          "descrição": "Código numérico da tecla '5' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_5_NUM",
          "valor": 101,
          "descrição": "Código numérico da tecla '5' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_6",
          "valor": 54,
          "descrição": "Código numérico da tecla '6' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_6_NUM",
          "valor": 102,
          "descrição": "Código numérico da tecla '6' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_7",
          "valor": 55,
          "descrição": "Código numérico da tecla '7' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_7_NUM",
          "valor": 103,
          "descrição": "Código numérico da tecla '7' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_8",
          "valor": 56,
          "descrição": "Código numérico da tecla '8' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_8_NUM",
          "valor": 104,
          "descrição": "Código numérico da tecla '8' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_9",
          "valor": 57,
          "descrição": "Código numérico da tecla '9' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_9_NUM",
          "valor": 105,
          "descrição": "Código numérico da tecla '9' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_A",
          "valor": 65,
          "descrição": "Código numérico da tecla 'A' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ABRE_COLCHETES",
          "valor": 91,
          "descrição": "Código numérico da tecla '[' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ADICAO",
          "valor": 107,
          "descrição": "Código numérico da tecla '+' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_AJUDA",
          "valor": 156,
          "descrição": "Código numérico da tecla AJUDA no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ALT",
          "valor": 18,
          "descrição": "Código numérico da tecla ALT no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_B",
          "valor": 66,
          "descrição": "Código numérico da tecla 'B' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_BACKSPACE",
          "valor": 8,
          "descrição": "Código numérico da tecla BACKSPACE no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_BARRA",
          "valor": 47,
          "descrição": "Código numérico da tecla '/' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_BARRA_INVERTIDA",
          "valor": 92,
          "descrição": "Código numérico da tecla '\\' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_C",
          "valor": 67,
          "descrição": "Código numérico da tecla 'C' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_CANCELAR",
          "valor": 3,
          "descrição": "Código numérico da tecla CANCELAR no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_CAPS_LOCK",
          "valor": 20,
          "descrição": "Código numérico da tecla CAPSLOCK no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_CONTROL",
          "valor": 17,
          "descrição": "Código numérico da tecla CONTROL no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_D",
          "valor": 68,
          "descrição": "Código numérico da tecla 'D' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_DECIMAL",
          "valor": 110,
          "descrição": "Código numérico da tecla DECIMAL no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_DELETAR",
          "valor": 127,
          "descrição": "Código numérico da tecla DELETE no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_DIVISAO",
          "valor": 111,
          "descrição": "Código numérico da tecla '/' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_E",
          "valor": 69,
          "descrição": "Código numérico da tecla 'E' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_END",
          "valor": 35,
          "descrição": "Código numérico da tecla END no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ENTER",
          "valor": 10,
          "descrição": "Código numérico da tecla ENTER no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ESC",
          "valor": 27,
          "descrição": "Código numérico da tecla ESC no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_ESPACO",
          "valor": 32,
          "descrição": "Código numérico da tecla ESPAÇO no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F",
          "valor": 70,
          "descrição": "Código numérico da tecla 'F' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F1",
          "valor": 112,
          "descrição": "Código numérico da tecla 'F1' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F10",
          "valor": 121,
          "descrição": "Código numérico da tecla 'F10' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F11",
          "valor": 122,
          "descrição": "Código numérico da tecla 'F11' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F12",
          "valor": 123,
          "descrição": "Código numérico da tecla 'F12' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F13",
          "valor": 61440,
          "descrição": "Código numérico da tecla 'F13' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F14",
          "valor": 61441,
          "descrição": "Código numérico da tecla 'F14' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F15",
          "valor": 61442,
          "descrição": "Código numérico da tecla 'F15' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F16",
          "valor": 61443,
          "descrição": "Código numérico da tecla 'F16' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F17",
          "valor": 61444,
          "descrição": "Código numérico da tecla 'F17' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F18",
          "valor": 61445,
          "descrição": "Código numérico da tecla 'F18' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F19",
          "valor": 61446,
          "descrição": "Código numérico da tecla 'F19' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F2",
          "valor": 113,
          "descrição": "Código numérico da tecla 'F2' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F20",
          "valor": 61447,
          "descrição": "Código numérico da tecla 'F20' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F21",
          "valor": 61448,
          "descrição": "Código numérico da tecla 'F21' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F22",
          "valor": 61449,
          "descrição": "Código numérico da tecla 'F22' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F23",
          "valor": 61450,
          "descrição": "Código numérico da tecla 'F23' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F24",
          "valor": 61451,
          "descrição": "Código numérico da tecla 'F24' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F3",
          "valor": 114,
          "descrição": "Código numérico da tecla 'F3' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F4",
          "valor": 115,
          "descrição": "Código numérico da tecla 'F4' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F5",
          "valor": 116,
          "descrição": "Código numérico da tecla 'F5' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F6",
          "valor": 117,
          "descrição": "Código numérico da tecla 'F6' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F7",
          "valor": 118,
          "descrição": "Código numérico da tecla 'F7' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F8",
          "valor": 119,
          "descrição": "Código numérico da tecla 'F8' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_F9",
          "valor": 120,
          "descrição": "Código numérico da tecla 'F9' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_FECHA_COLCHETES",
          "valor": 93,
          "descrição": "Código numérico da tecla ']' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_G",
          "valor": 71,
          "descrição": "Código numérico da tecla 'G' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_H",
          "valor": 72,
          "descrição": "Código numérico da tecla 'H' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_HOME",
          "valor": 36,
          "descrição": "Código numérico da tecla HOME no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_I",
          "valor": 73,
          "descrição": "Código numérico da tecla 'I' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_IGUAL",
          "valor": 61,
          "descrição": "Código numérico da tecla '=' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_INSERT",
          "valor": 155,
          "descrição": "Código numérico da tecla INSERT no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_J",
          "valor": 74,
          "descrição": "Código numérico da tecla 'J' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_K",
          "valor": 75,
          "descrição": "Código numérico da tecla 'K' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_L",
          "valor": 76,
          "descrição": "Código numérico da tecla 'L' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_LIMPAR",
          "valor": 12,
          "descrição": "Código numérico da tecla LIMPAR no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_M",
          "valor": 77,
          "descrição": "Código numérico da tecla 'M' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_MENOS",
          "valor": 45,
          "descrição": "Código numérico da tecla '-' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_MENU_CONTEXTO",
          "valor": 525,
          "descrição": "Código numérico da tecla MENU DE CONTEXTO no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_MULTIPLICACAO",
          "valor": 106,
          "descrição": "Código numérico da tecla '*' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_N",
          "valor": 78,
          "descrição": "Código numérico da tecla 'N' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_NUM_LOCK",
          "valor": 144,
          "descrição": "Código numérico da tecla NUM LOCK no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_NUM_SEPARADOR_DECIMAL",
          "valor": 108,
          "descrição": "Código numérico da tecla de separador decimal (',' ou '.') no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_O",
          "valor": 79,
          "descrição": "Código numérico da tecla 'O' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_P",
          "valor": 80,
          "descrição": "Código numérico da tecla 'P' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PAGE_DOWN",
          "valor": 34,
          "descrição": "Código numérico da tecla PAGE DOWN no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PAGE_UP",
          "valor": 33,
          "descrição": "Código numérico da tecla PAGE UP no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PAUSE",
          "valor": 19,
          "descrição": "Código numérico da tecla PAUSE/BREAK no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PONTO_FINAL",
          "valor": 46,
          "descrição": "Código numérico da tecla '.' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PONTO_VIRGULA",
          "valor": 59,
          "descrição": "Código numérico da tecla ';' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_PRINTSCREEN",
          "valor": 154,
          "descrição": "Código numérico da tecla PRINT SCREEN no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_Q",
          "valor": 81,
          "descrição": "Código numérico da tecla 'Q' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_R",
          "valor": 82,
          "descrição": "Código numérico da tecla 'R' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_S",
          "valor": 83,
          "descrição": "Código numérico da tecla 'S' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SCROLL_LOCK",
          "valor": 145,
          "descrição": "Código numérico da tecla SCROLL LOCK no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SETA_ABAIXO",
          "valor": 40,
          "descrição": "Código numérico da tecla SETA ABAIXO no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SETA_ACIMA",
          "valor": 38,
          "descrição": "Código numérico da tecla SETA ACIMA no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SETA_DIREITA",
          "valor": 39,
          "descrição": "Código numérico da tecla SETA DIREITA no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SETA_ESQUERDA",
          "valor": 37,
          "descrição": "Código numérico da tecla SETA ESQUERDA no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SHIFT",
          "valor": 16,
          "descrição": "Código numérico da tecla SHIFT no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_SUBTRACAO",
          "valor": 109,
          "descrição": "Código numérico da tecla '-' no teclado numérico",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_T",
          "valor": 84,
          "descrição": "Código numérico da tecla 'T' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_TAB",
          "valor": 9,
          "descrição": "Código numérico da tecla TAB no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_U",
          "valor": 85,
          "descrição": "Código numérico da tecla 'U' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_V",
          "valor": 86,
          "descrição": "Código numérico da tecla 'V' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_VIRGULA",
          "valor": 44,
          "descrição": "Código numérico da tecla ',' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_W",
          "valor": 87,
          "descrição": "Código numérico da tecla 'W' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_WINDOWS",
          "valor": 524,
          "descrição": "Código numérico da tecla de acesso ao menu Iniciar no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_X",
          "valor": 88,
          "descrição": "Código numérico da tecla 'X' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_Y",
          "valor": 89,
          "descrição": "Código numérico da tecla 'Y' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        },
        {
          "nome": "TECLA_Z",
          "valor": 90,
          "descrição": "Código numérico da tecla 'Z' no teclado",
          "tipo": {
            "primitivo": "inteiro"
          }
        }
      ],
      "funções": [
        {
          "nome": "alguma_tecla_pressionada",
          "descrição": "Testa se existe alguma tecla pressionada neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o resultado do teste. `verdadeiro` se houver uma tecla pressionada no momento do teste. Caso contrário, retorna `falso`"
          },
          "parâmetros": []
        },
        {
          "nome": "caracter_tecla",
          "descrição": "Obtém o caracter correspondente a uma determinada `tecla`",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o caracter correspondente à tecla"
          },
          "parâmetros": [
            {
              "nome": "tecla",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a tecla para a qual se quer obter o caracter"
            }
          ]
        },
        {
          "nome": "ler_tecla",
          "descrição": "Aguarda até que uma tecla seja digitada, isto é, foi pressionada e depois solta, e captura o seu código",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o código da tecla lida"
          },
          "parâmetros": []
        },
        {
          "nome": "tecla_pressionada",
          "descrição": "Testa se uma determinada `tecla` está pressionada neste instante",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "o resultado do teste. `Verdadeiro` se a `tecla` estiver pressionada no momento do teste. Caso contrário, retorna `falso`"
          },
          "parâmetros": [
            {
              "nome": "tecla",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o código da tecla que será testada"
            }
          ]
        }
      ]
    },
    {
      "nome": "Texto",
      "descrição": "Esta biblioteca contém funções para manipular textos (valores do tipo `cadeia`)",
      "constantes": [],
      "funções": [
        {
          "nome": "caixa_alta",
          "descrição": "Converte todas as letras de uma `cadeia` em maiúsculas",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "uma nova `cadeia` com as letras em maiúsculas"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será convertido"
            }
          ]
        },
        {
          "nome": "caixa_baixa",
          "descrição": "Converte todas as letras de uma `cadeia` em minúsculas",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "uma nova `cadeia` com as letras em minúsculas"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será convertido"
            }
          ]
        },
        {
          "nome": "extrair_subtexto",
          "descrição": "Extrai um trecho da `cadeia`, do caractere na `posicao_inicial` até o caractere anterior à `posicao_final`. Exemplos:\n\n`extrair_subtexto(\"salgado\", 0, 3) // resultado: \"sal\"`\n\n`extrair_subtexto(\"salgado\", 3, 7) // resultado: \"gado\"`\n\n`extrair_subtexto(\"salgado\", 1, 5) // resultado: \"alga\"`\n\nSe a `posicao_inicial` for negativa, se a `posicao_final` for maior que o número de caracteres da `cadeia` ou se a `posicao_inicial` for maior que a `posicao_final`, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o trecho extraído"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto do qual será extraído o trecho"
            },
            {
              "nome": "posicao_inicial",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do primeiro caractere do trecho, começando em 0"
            },
            {
              "nome": "posicao_final",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição logo depois do último caractere do trecho (o caractere nessa posição não é incluído)"
            }
          ]
        },
        {
          "nome": "numero_caracteres",
          "descrição": "Conta quantos caracteres uma `cadeia` tem",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de caracteres da `cadeia`, contando os espaços"
          },
          "parâmetros": [
            {
              "nome": "cadeia",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto cujos caracteres serão contados"
            }
          ]
        },
        {
          "nome": "obter_caracter",
          "descrição": "Obtém o caractere que está na posição informada da `cadeia`.\n\nAs posições começam em 0, então o `indice` deve estar entre 0 e o número de caracteres da `cadeia` menos 1. Fora desse intervalo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o caractere na posição informada"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto do qual será obtido o caractere"
            },
            {
              "nome": "indice",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição do caractere, começando em 0"
            }
          ]
        },
        {
          "nome": "posicao_texto",
          "descrição": "Procura um trecho de texto dentro de uma `cadeia` e retorna a posição da primeira ocorrência",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a posição (a partir de 0) em que começa a primeira ocorrência do texto, ou -1 se ele não for encontrado"
          },
          "parâmetros": [
            {
              "nome": "texto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o trecho que será procurado"
            },
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto onde será feita a procura"
            },
            {
              "nome": "posicao_inicial",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a posição a partir da qual a procura começa. Para procurar desde o início da `cadeia`, use 0."
            }
          ]
        },
        {
          "nome": "preencher_a_esquerda",
          "descrição": "Acrescenta o caractere informado à esquerda da `cadeia`, repetindo-o até que ela fique com o `tamanho` indicado.\n\nSe a `cadeia` já tiver o `tamanho` indicado ou mais, ela é retornada sem alterações.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "a `cadeia` preenchida à esquerda"
          },
          "parâmetros": [
            {
              "nome": "car",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o caractere que será acrescentado à esquerda da `cadeia`"
            },
            {
              "nome": "tamanho",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número de caracteres que a `cadeia` terá depois de preenchida"
            },
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será preenchido"
            }
          ]
        },
        {
          "nome": "substituir",
          "descrição": "Procura um trecho de texto em uma `cadeia` e substitui todas as ocorrências por outro texto",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "uma nova `cadeia` com as substituições feitas"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto onde será feita a procura"
            },
            {
              "nome": "texto_pesquisa",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o trecho que será procurado"
            },
            {
              "nome": "texto_substituto",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que entrará no lugar de cada ocorrência"
            }
          ]
        }
      ]
    },
    {
      "nome": "Tipos",
      "descrição": "Esta biblioteca contém funções para verificar se um valor pode ser convertido de um tipo de dado do Portugol para outro e para fazer essa conversão",
      "constantes": [],
      "funções": [
        {
          "nome": "cadeia_e_caracter",
          "descrição": "Verifica se a `cadeia` tem exatamente um caractere e, portanto, pode ser convertida em `caracter`",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se a `cadeia` tiver exatamente um caractere; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será verificado"
            }
          ]
        },
        {
          "nome": "cadeia_e_inteiro",
          "descrição": "Verifica se a `cadeia` representa um número `inteiro` escrito na base informada",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se a `cadeia` representar um número `inteiro` na base informada; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será verificado"
            },
            {
              "nome": "base",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a base de numeração em que o número está escrito: 2 (binária, ex.: `0b1001`, `101`), 10 (decimal, ex.: `52`, `-34`) ou 16 (hexadecimal, ex.: `0xFF5AC`, `ff00ff`). Qualquer outro valor causa um erro de execução.\n"
            }
          ]
        },
        {
          "nome": "cadeia_e_logico",
          "descrição": "Verifica se a `cadeia` representa um valor `logico`, ou seja, se é `verdadeiro` ou `falso` escrito em letras minúsculas",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se a `cadeia` representar um valor `logico`; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será verificado"
            }
          ]
        },
        {
          "nome": "cadeia_e_real",
          "descrição": "Verifica se a `cadeia` representa um número `real` escrito com ponto decimal, com dígitos antes e depois do ponto (ex.: `3.14`, `-0.5`)\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se a `cadeia` representar um número `real`; caso contrário, `falso`. Um número sem ponto decimal, como `10`, resulta em `falso`.\n"
          },
          "parâmetros": [
            {
              "nome": "cad",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o texto que será verificado"
            }
          ]
        },
        {
          "nome": "cadeia_para_caracter",
          "descrição": "Converte uma `cadeia` de um só caractere em um valor do tipo `caracter`.\n\nSe a `cadeia` estiver vazia ou tiver mais de um caractere, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o único caractere da `cadeia`"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "cadeia_para_inteiro",
          "descrição": "Converte uma `cadeia` que representa um número inteiro, escrito na base informada, em um valor do tipo `inteiro`.\n\nSe a `cadeia` não representar um número inteiro nessa base, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número representado na `cadeia`"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o valor que será convertido"
            },
            {
              "nome": "base",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a base de numeração em que o número está escrito: 2 (binária, ex.: `0b1001`, `101`), 10 (decimal, ex.: `52`, `-34`) ou 16 (hexadecimal, ex.: `0xFF5AC`, `ff00ff`). Qualquer outro valor causa um erro de execução.\n"
            }
          ]
        },
        {
          "nome": "cadeia_para_logico",
          "descrição": "Converte a `cadeia` `\"verdadeiro\"` ou `\"falso\"` no valor `logico` correspondente.\n\nQualquer outro texto, inclusive com letras maiúsculas, causa um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` para a `cadeia` `\"verdadeiro\"` e `falso` para a `cadeia` `\"falso\"`\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "cadeia_para_real",
          "descrição": "Converte uma `cadeia` que representa um número (ex.: `3.14`, `10`) em um valor do tipo `real`.\n\nSe a `cadeia` não representar um número, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o número representado na `cadeia`"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "cadeia"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "caracter_e_inteiro",
          "descrição": "Verifica se o `caracter` é um algarismo (de `'0'` a `'9'`) e, portanto, pode ser convertido em `inteiro` com `caracter_para_inteiro`",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o `caracter` for um algarismo; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "car",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o caractere que será verificado"
            }
          ]
        },
        {
          "nome": "caracter_e_logico",
          "descrição": "Verifica se o `caracter` representa um valor `logico`, ou seja, se é `'S'` ou `'N'` (maiúsculo ou minúsculo)",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o `caracter` for `'S'`, `'s'`, `'N'` ou `'n'`; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "car",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o caractere que será verificado"
            }
          ]
        },
        {
          "nome": "caracter_para_cadeia",
          "descrição": "Converte um valor do tipo `caracter` em uma `cadeia` com esse único caractere",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "uma `cadeia` com o caractere"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "caracter_para_inteiro",
          "descrição": "Converte um `caracter` que é um algarismo (de `'0'` a `'9'`) no número `inteiro` correspondente. Ex.: `'7'` resulta em 7.\n\nSe o `caracter` não for um algarismo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número do algarismo"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "caracter_para_logico",
          "descrição": "Converte o `caracter` `'S'` ou `'N'` (maiúsculo ou minúsculo) em um valor do tipo `logico`.\n\nQualquer outro caractere causa um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` para `'S'` ou `'s'`; `falso` para `'N'` ou `'n'`\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "caracter"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "inteiro_e_caracter",
          "descrição": "Verifica se o número `inteiro` tem um só algarismo (de 0 a 9) e, portanto, pode ser convertido em `caracter` com `inteiro_para_caracter`",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`verdadeiro` se o número estiver entre 0 e 9; caso contrário, `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "int",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o número que será verificado"
            }
          ]
        },
        {
          "nome": "inteiro_para_cadeia",
          "descrição": "Converte um valor do tipo `inteiro` em uma `cadeia` com o número escrito na base informada",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o número escrito na base informada. Nas bases 2 e 16, o texto não tem prefixo e é completado com zeros à esquerda até ter 32 e 8 dígitos, respectivamente. Ex.: `inteiro_para_cadeia(255, 16)` retorna `\"000000FF\"`.\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o valor que será convertido"
            },
            {
              "nome": "base",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "a base de numeração do texto gerado: 2 (binária), 10 (decimal) ou 16 (hexadecimal). Qualquer outro valor causa um erro de execução.\n"
            }
          ]
        },
        {
          "nome": "inteiro_para_caracter",
          "descrição": "Converte um número `inteiro` de um só algarismo (de 0 a 9) no `caracter` desse algarismo. Ex.: 7 resulta em `'7'`.\n\nPara números fora desse intervalo, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "o caractere do algarismo"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "inteiro_para_logico",
          "descrição": "Converte um valor do tipo `inteiro` em um valor do tipo `logico`",
          "retorno": {
            "tipo": {
              "primitivo": "logico"
            },
            "descrição": "`falso` se o valor for menor ou igual a 0; `verdadeiro` se for maior que 0\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "inteiro_para_real",
          "descrição": "Converte um valor do tipo `inteiro` em um valor do tipo `real`",
          "retorno": {
            "tipo": {
              "primitivo": "real"
            },
            "descrição": "o mesmo número, como `real`. Ex.: 5 resulta em 5.0.\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "logico_para_cadeia",
          "descrição": "Converte um valor do tipo `logico` em uma `cadeia`",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "`\"verdadeiro\"` ou `\"falso\"`, conforme o valor\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "logico_para_caracter",
          "descrição": "Converte um valor do tipo `logico` em um valor do tipo `caracter`",
          "retorno": {
            "tipo": {
              "primitivo": "caracter"
            },
            "descrição": "`'S'` se o valor for `verdadeiro`; `'N'` se for `falso`\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "logico_para_inteiro",
          "descrição": "Converte um valor do tipo `logico` em um valor do tipo `inteiro`",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "1 se o valor for `verdadeiro`; 0 se for `falso`"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "logico"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "real_para_cadeia",
          "descrição": "Converte um valor do tipo `real` em uma `cadeia`",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o número escrito como texto, com ponto decimal. Ex.: 2.5 resulta em `\"2.5\"`.\n"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        },
        {
          "nome": "real_para_inteiro",
          "descrição": "Converte um valor do tipo `real` em um valor do tipo `inteiro`, descartando a parte fracionária (sem arredondar). Ex.: 9.56 resulta em 9, e -9.56 resulta em -9.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "a parte inteira do número"
          },
          "parâmetros": [
            {
              "nome": "valor",
              "tipo": {
                "primitivo": "real"
              },
              "descrição": "o valor que será convertido"
            }
          ]
        }
      ]
    },
    {
      "nome": "Util",
      "descrição": "Esta biblioteca contém funções de uso geral, como sortear números, pausar o programa e contar os elementos de vetores e matrizes",
      "constantes": [],
      "funções": [
        {
          "nome": "aguarde",
          "descrição": "Pausa a execução do programa pelo tempo informado",
          "retorno": {
            "tipo": {
              "primitivo": "vazio"
            }
          },
          "parâmetros": [
            {
              "nome": "intervalo",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o tempo de pausa, em milissegundos (1000 milissegundos equivalem a 1 segundo)"
            }
          ]
        },
        {
          "nome": "numero_colunas",
          "descrição": "Conta o número de colunas de uma matriz",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de colunas da matriz"
          },
          "parâmetros": [
            {
              "nome": "matriz",
              "tipo": {
                "primitivo": "*",
                "dimensão": "matriz"
              },
              "descrição": "a matriz cujas colunas serão contadas"
            }
          ]
        },
        {
          "nome": "numero_elementos",
          "descrição": "Conta o número de elementos de um vetor",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de elementos do vetor"
          },
          "parâmetros": [
            {
              "nome": "vetor",
              "tipo": {
                "primitivo": "*",
                "dimensão": "vetor"
              },
              "descrição": "o vetor cujos elementos serão contados"
            }
          ]
        },
        {
          "nome": "numero_linhas",
          "descrição": "Conta o número de linhas de uma matriz",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número de linhas da matriz"
          },
          "parâmetros": [
            {
              "nome": "matriz",
              "tipo": {
                "primitivo": "*",
                "dimensão": "matriz"
              },
              "descrição": "a matriz cujas linhas serão contadas"
            }
          ]
        },
        {
          "nome": "obter_diretorio_usuario",
          "descrição": "Obtém o caminho da pasta pessoal do usuário no sistema operacional.\n\nNo Portugol Webstudio, que funciona no navegador, sempre retorna `\"/home\"`.\n",
          "retorno": {
            "tipo": {
              "primitivo": "cadeia"
            },
            "descrição": "o caminho da pasta do usuário"
          },
          "parâmetros": []
        },
        {
          "nome": "sorteia",
          "descrição": "Sorteia um número inteiro entre os valores mínimo e máximo, incluindo os dois.\n\nSe o `minimo` for maior ou igual ao `maximo`, ocorre um erro de execução.\n",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o número sorteado"
          },
          "parâmetros": [
            {
              "nome": "minimo",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o menor número que pode ser sorteado"
            },
            {
              "nome": "maximo",
              "tipo": {
                "primitivo": "inteiro"
              },
              "descrição": "o maior número que pode ser sorteado"
            }
          ]
        },
        {
          "nome": "tempo_decorrido",
          "descrição": "Obtém o tempo que passou desde que a biblioteca foi incluída, no início do programa",
          "retorno": {
            "tipo": {
              "primitivo": "inteiro"
            },
            "descrição": "o tempo decorrido, em milissegundos"
          },
          "parâmetros": []
        }
      ]
    }
  ]
}
